const FORTNOX_STATUS = {
  UNSENT: "UNSENT",
  SENT: "SENT",
  VERIFIED: "VERIFIED",
};

const getFortnoxStatusTranslation = (status) => {
  switch (status) {
    case FORTNOX_STATUS.UNSENT:
      return "Ej aktiverat";
    case FORTNOX_STATUS.SENT:
      return "Påbörjat";
    case FORTNOX_STATUS.VERIFIED:
      return "Aktiverat";
    default:
      return "";
  }
};

const getFortnoxStatusColor = (status) => {
  switch (status) {
    case FORTNOX_STATUS.UNSENT:
      return "info";
    case FORTNOX_STATUS.SENT:
      return "warning";
    case FORTNOX_STATUS.VERIFIED:
      return "success";
    default:
      return "default";
  }
};

export { FORTNOX_STATUS, getFortnoxStatusColor, getFortnoxStatusTranslation };
